module.exports = __webpack_public_path__ + "static/phx-ts-4ad71949795b601560428cddf6d64ff4.jpg";